import React from 'react';

const Pin = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="37" viewBox="0 0 20 34.892">
      <g transform="matrix(1.185585 0 0 1.185585 -965.7731 -331.78383)">
        <path
          d="M817.112 282.97c-1.258 1.343-2.046 3.3-2.016 5.14.064 3.845 1.797 5.3 4.568 10.592.998 2.33 2.04 4.792 3.03 8.873.138.602.272 1.16.334 1.21s.196-.513.334-1.115c.99-4.08 2.033-6.543 3.03-8.87 2.77-5.292 4.504-6.747 4.568-10.592.03-1.84-.76-3.798-2.018-5.14-1.437-1.534-3.605-2.67-5.916-2.717s-4.48 1.088-5.918 2.622z"
          fill="#ff4646"
          stroke="#d73534"
        />
        <circle r="3.036" cy="288.253" cx="823.031" fill="#590000" />
      </g>
    </svg>
  );
};

export default Pin;
